import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ShieldX, ArrowLeft, Home } from "lucide-react";

import { Button } from "../../components/ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "../../components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "../../components/ui/alert";

export default function Error400Shadcn() {
  const { t } = useTranslation("common");
  const history = useHistory();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center mb-4">
            <ShieldX className="h-8 w-8 text-destructive" />
          </div>
          <h1 className="text-4xl font-bold text-destructive">400</h1>
          <p className="text-xl font-semibold text-foreground mt-2">
            {t("error.Access Denied") || "Access Denied"}
          </p>
        </CardHeader>
        <CardContent>
          <Alert variant="destructive">
            <ShieldX className="h-4 w-4" />
            <AlertTitle>{t("error.Permission Error") || "Permission Error"}</AlertTitle>
            <AlertDescription>
              {t("error.User does not have the right permissions") ||
                "You do not have the required permissions to access this resource."}
            </AlertDescription>
          </Alert>
        </CardContent>
        <CardFooter className="flex gap-2 justify-center">
          <Button variant="outline" onClick={() => history.goBack()}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            {t("button.Go Back") || "Go Back"}
          </Button>
          <Button onClick={() => history.push("/profile")}>
            <Home className="mr-2 h-4 w-4" />
            {t("button.Go to Profile") || "Go to Profile"}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
